<template>
  <div class="mask" v-if="visible">
    <div class="loginBox">
      <div class="title">登录</div>
      <p class="tips">先登录再查看</p>
      <div style="padding: 30px">
        <div style="margin-bottom: 20px; text-align: center">
          <span style="font-size: 14px">登录类型：</span>
          <div style="width: 230px; display: inline-block">
            <el-radio v-model="loginType" label="1">机构代码</el-radio>
            <el-radio v-model="loginType" label="2">成员名称</el-radio>
          </div>
        </div>
        <div style="margin-bottom: 20px; text-align: center">
          <span v-if="loginType == '1'" style="font-size: 14px"
            >机构代码：</span
          >
          <span v-else style="font-size: 14px">成员名称：</span>
          <el-input
            size="medium"
            style="width: 230px"
            class="input"
            v-model="organFlag"
            :placeholder="
              loginType == '1' ? '请输入机构代码' : '请输入成员名称'
            "
          ></el-input>
        </div>
        <div style="margin-bottom: 20px; text-align: center">
          <span style="font-size: 14px">用户账号：</span>
          <el-input
            size="medium"
            style="width: 230px"
            class="input"
            v-model="userCode"
            placeholder="请输入用户账号"
          ></el-input>
        </div>
        <div style="margin-bottom: 40px; text-align: center">
          <span style="font-size: 14px">登录密码：</span>
          <el-input
            style="width: 230px"
            size="medium"
            class="input"
            show-password
            v-model="password"
            placeholder="请输入登录密码"
          ></el-input>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            size="medium"
            :loading="loading"
            @click="login"
            >登录</el-button
          >
          <el-button style="margin-left: 30px" v-if="cancel" @click="back"
            >返回</el-button
          >
          <el-button style="margin-left: 30px" v-else @click="cancelfn"
            >取消</el-button
          >
        </div>
        <div>
          <el-dropdown style="margin-left: 20px; float: right">
            <span
              class="el-dropdown-link"
              style="color: #1890ff; font-size: 14px"
            >
              注册
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="padding: 0 20px">
                <router-link :to="{ name: 'registerComUser' }"
                  >成员注册</router-link
                >
              </el-dropdown-item>
              <el-dropdown-item style="padding: 0 20px">
                <router-link :to="{ name: 'registerUser' }"
                  >用户注册</router-link
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <router-link :to="{ name: 'forgetPassword' }">
            <span style="float: left; font-size: 14px; color: #666"
              >忘记密码</span
            >
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/home";
const setCookie = (name, value) => {
  var exp = new Date();
  exp.setTime(exp.getTime() + 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
};
export default {
  props: {
    cancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      mobileCode: undefined,
      password: undefined,
      organFlag: undefined,
      userCode: undefined,
      loginType: "1",
    };
  },
  methods: {
    cancelfn() {
      this.visible = false;
    },
    back() {
      window.history.back(-1);
    },
    show() {
      this.mobileCode = undefined;
      this.password = undefined;
      this.loading = false;
      this.visible = true;
    },
    login() {
      if (!this.organFlag) {
        if (this.loginType == "1") {
          this.$message.error("请输入机构代码");
        } else {
          this.$message.error("请输入成员名称");
        }

        return;
      }
      if (!this.userCode) {
        this.$message.error("请输入用户账号");
        return;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return;
      }
      this.loading = true;
      login({
        op: "login",
        organFlag: this.organFlag,
        userCode: this.userCode,
        password: this.password,
        loginType: this.loginType,
        doLogin: 1,
      }).then((res) => {
        if (res.success) {
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          setCookie("organFlag", this.organFlag);
          setCookie("userCode", this.userCode);
          setCookie("loginType", this.loginType);
          setCookie("password", this.password);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
  left: 0;
  top: 0;
  .loginBox {
    width: 400px;
    height: 440px;
    border-radius: 10px;
    margin: 100px auto;
    background: #fff;
    .title {
      line-height: 90px;
      text-align: center;
      font-size: 25px;
    }
    .tips {
      font-size: 14px;
      text-align: center;
      color: #f89619;
    }
  }
}
</style>